export const articles = {

    // Document name and article id

    SIGNUP: '614c7c6812c07c18afdd6dfc',
    LOGIN: '6128c33312c07c18afdceb4e',
    ATTORNEY_OF_RECORD: '615190910332cb5b9e9ae325',
    FILE_PETITION: '6128d16000c03d6720751bff',
    DOWNLOAD_AND_UPLOAD_DOCUMENT: '6128d32ff886c9486f8dcc11',
    GAL_ACCEPT_CASE: '61515a9f2b380503dfdf4d70',
    UPLOAD_AND_SET_INVENTORY_FEES: '615163b90754e74465f13e5b',
    BOND_PACKAGE: '615163a10332cb5b9e9ae245',
    APPOINT_GUARDIAN: '61515f920754e74465f13e53',
    ASSIGN_GAL_TO_CASE: '61515f6a0332cb5b9e9ae23e',
    SET_HEARING_DATE: '61515d7a0332cb5b9e9ae23b',
    REVIEW_PUBLISHED_FORM: '61515d5b0332cb5b9e9ae239',
    REVIEW_FORM: '61515cf612c07c18afdd7c1e',
    TASKBAR_FEATURES: '61515c1212c07c18afdd7c1b',
    COMMON_TASKBAR_FEATURES: '615157400754e74465f13e3a',
    CASE_OVERVIEW: '61515b0100c03d672075aa97',
    FILE_ANNUAL_REPORT: '61515a100754e74465f13e42',
    BACKGROUND_CHECK: '615159ab0754e74465f13e3f',
    MAKE_PAYMENT: '615159060332cb5b9e9ae227',
    SET_PAYMENT_PREFERENCE: '6151589000c03d672075aa83',


    // Beacon Id
    BEACON_ID: '87de7b2f-8ba1-4d80-8329-d953cb72b9a2',
    
}


// WEBPACK FOOTER //
// ./src/app/helpscout/hsdocuments.ts